import React from 'react';
import VirtualMirror from './VirtualMirror';
import { ContextContainer } from './context';

export default ({ ...props }) => (
  <ContextContainer>
    <VirtualMirror {...props} />
  </ContextContainer>
);
